module.exports = __webpack_public_path__ + "static/media/free-review-banner.0074e329.png";